function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3d3d3d}.cls-2{fill:#9b9a9a}.cls-3{fill:#fff}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "logo");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("polygon", {
  points: "432.12 373.42 216.53 498.43 .47 374.23 0 125.01 215.59 0 431.66 124.2 432.12 373.42"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "77.67 157.94 125.42 186.15 125.81 397.91 78.07 368.9 77.67 157.94",
  className: "cls-1"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "217.27 132.19 125.42 186.15 77.67 157.94 215.99 78.47 354.11 157.43 307.28 185.81 217.27 132.19",
  className: "cls-2"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "216.58 397.74 354.4 316.64 354.11 157.43 307.28 185.81 309.02 289.53 216.48 344.09 216.58 397.74",
  className: "cls-3"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "125.81 397.91 172.69 371.88 172.59 319.54 125.71 345.29 125.81 397.91",
  className: "cls-3"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "216.58 397.74 172.69 371.88 172.59 319.54 216.48 344.09",
  className: "cls-1"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "172.39 213.33 216.04 237.88 216.38 289.19 172.49 264.13 172.39 213.33",
  className: "cls-1"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "215.95 188.1 260.65 213.16 216.04 237.88 172.39 213.33 215.95 188.1",
  className: "cls-2"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "260.74 263.45 216.38 289.19 216.04 237.88 260.65 213.16 260.74 263.45",
  className: "cls-3"
}));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 432.12 498.43",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.5f8fdd09.svg";
export { ForwardRef as ReactComponent };